import React from 'react';

export default function Careers() {
    return (
        <div className="bg-light min-h-screen pt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-bold text-dark mb-6">Careers at Konnectt</h1>
                    <p className="text-xl text-body max-w-3xl mx-auto">
                        Join a team of visionaries dedicated to connecting the world's best talent with game-changing opportunities.
                    </p>
                </div>

                <div className="bg-white p-12 rounded-[40px] shadow-sm border border-gray-100 mb-16">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
                        <div>
                            <h4 className="text-3xl font-bold text-primary mb-2">500+</h4>
                            <p className="text-body font-medium">Internal Team Members</p>
                        </div>
                        <div>
                            <h4 className="text-3xl font-bold text-primary mb-2">15+</h4>
                            <p className="text-body font-medium">Countries</p>
                        </div>
                        <div>
                            <h4 className="text-3xl font-bold text-primary mb-2">Unlimited</h4>
                            <p className="text-body font-medium">Growth Potential</p>
                        </div>
                    </div>
                </div>

                <div className="max-w-3xl mx-auto space-y-12">
                    <section>
                        <h2 className="text-2xl font-bold text-dark mb-4">Why Work With Us?</h2>
                        <p className="text-body leading-relaxed">
                            At Konnectt, we don't just fill roles; we build futures. We offer a dynamic, inclusive environment where your ideas are valued and your professional growth is our priority. From flexible work arrangements to comprehensive health benefits, we ensure our team is well-supported.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-dark mb-4">Open Positions</h2>
                        <div className="p-8 text-center bg-gray-50 border border-dashed border-gray-300 rounded-3xl mb-12">
                            <p className="text-body font-medium">We are currently updating our internal careers portal. Please check back soon or send your resume to <a href="mailto:careers@konnectt.in" className="text-primary hover:underline">careers@konnectt.in</a></p>
                        </div>
                    </section>

                    <section className="bg-white p-8 md:p-12 rounded-[40px] shadow-sm border border-gray-100">
                        <h2 className="text-3xl font-bold text-dark mb-2 text-center">Join Our Talent Pool</h2>
                        <p className="text-body text-center mb-10">Don't see a perfect fit? Tell us about yourself and we'll keep you in mind for future openings.</p>

                        <form className="grid grid-cols-1 md:grid-cols-2 gap-6" onSubmit={(e) => { e.preventDefault(); alert('Application submitted successfully!'); }}>
                            <div className="space-y-2">
                                <label className="text-sm font-bold text-dark ml-1">Full Name</label>
                                <input type="text" required placeholder="John Doe" className="w-full px-5 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-primary/10 transition-all outline-none" />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-bold text-dark ml-1">Email Address</label>
                                <input type="email" required placeholder="john@example.com" className="w-full px-5 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-primary/10 transition-all outline-none" />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-bold text-dark ml-1">Area of Interest</label>
                                <select className="w-full px-5 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-primary/10 transition-all outline-none">
                                    <option>Engineering</option>
                                    <option>Design</option>
                                    <option>Marketing</option>
                                    <option>Sales</option>
                                    <option>Human Resources</option>
                                    <option>Operations</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-bold text-dark ml-1">Experience Level</label>
                                <select className="w-full px-5 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-primary/10 transition-all outline-none">
                                    <option>Entry Level</option>
                                    <option>Mid Level</option>
                                    <option>Senior Level</option>
                                    <option>Executive</option>
                                </select>
                            </div>
                            <div className="space-y-2 md:col-span-2">
                                <label className="text-sm font-bold text-dark ml-1">Why do you want to join Konnectt?</label>
                                <textarea rows="4" placeholder="Tell us about your passion..." className="w-full px-5 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-primary/10 transition-all outline-none resize-none"></textarea>
                            </div>
                            <div className="md:col-span-2 text-center">
                                <button type="submit" className="px-12 py-4 bg-primary text-white font-bold rounded-2xl hover:bg-blue-600 transition-all shadow-lg shadow-primary/20 hover:-translate-y-1">
                                    Submit Application
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}
